import { useEffect } from "react";

export function useServerEvents(channel: string | null, onEvent: () => void) {
  useEffect(() => {
    if (!channel) return;
    const es = new EventSource(`/api/events/${encodeURIComponent(channel)}`);
    es.addEventListener("change", onEvent);
    return () => es.close();
  }, [channel, onEvent]);
}
